
import s from './ResearchDevelopment'
export default s
